import { TGetIndustryListResDto } from "@/api/services/global/industry/dtos/get-industry-list.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { TOption } from "@/types/common";
import { globalApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

// hasLearner is scoped by companyId (company) or rsoId (RSO). Matches Main-GetIndustryListQueryDto.
type TGetIndustryListParams = { companyId?: number | string; rsoId?: number | string };

export const fetchIndustryListApi = async (params?: TGetIndustryListParams): Promise<TGetIndustryListResDto> => {
  const { data } = await globalApi.get<TGetIndustryListResDto>("/industries", { params });
  return data;
};

export const useGetIndustryList = (params?: TGetIndustryListParams) => {
  const { data, isLoading, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.INDUSTRY_LIST, params?.companyId, params?.rsoId],
    queryFn: () => fetchIndustryListApi(params),
  });
  const publishedIndustries = useMemo(() => (data?.data ?? []).filter((item) => item.isPublished), [data]);

  const industryOptions: TOption[] = useMemo(() => publishedIndustries.map((item) => ({ label: item.name, value: item.id })), [publishedIndustries]);

  return { data: publishedIndustries, industryOptions, isLoading, ...rest };
};
